import * as Models from '@models';

export const modelsMap = new Map<string, any>([
  ['users', Models.User],
  ['ticket-reports', Models.TicketReport],
  ['voucher-reports', Models.VoucherReport],
  ['ride-reports', Models.RideReport],
  ['ride-passengers-reports', Models.RidePassengersReport],
]);
